import { TRACKERS } from 'lib/analytics/trackers';

/**
 * Reddit Ads Pixel — bootstrapped after consent. The id lives in the tracker table.
 *
 * The id is the Reddit ad-account id; Reddit uses the same value for the
 * account's default pixel (Ads API `GET /api/v3/ad_accounts/{id}/pixels`
 * returns `id: "a2_jm19w71venkj"`).
 *
 * SCOPE: ultrahuman.com only, PageVisit only. `Purchase` and the
 * CheckoutStarted family fire on the Shopify checkout domains via the official
 * Reddit Shopify app, not from this repo.
 */

export const REDDIT_PIXEL_ID = TRACKERS.reddit.id;

/**
 * First-party cookie holding Reddit's click id. Host-only, exactly like Meta's
 * `_uh_fbclid`: it is read on www and forwarded into the Shopify checkout URL
 * as `attributes[rdt_cid]`, which Shopify persists onto the order — that, not
 * cookie scope, is how the click id would reach the server. `rdt_cid` is also
 * in FORWARDED_PARAM_KEYS so a same-session click carries through directly;
 * the cookie covers the visitor who clicks, browses, and converts later.
 *
 * Nothing reads these order attributes yet — there is no Conversions API
 * sender in this repo for Reddit or for Meta. This is groundwork.
 */
export const REDDIT_CLICK_ID_COOKIE = '_uh_rdt_cid';

/** Reddit's click-id query param, appended to ad landing URLs. */
export const REDDIT_CLICK_ID_PARAM = 'rdt_cid';

/** Days the click id is retained — matches the ad account's click window (MONTH). */
export const REDDIT_CLICK_ID_MAX_AGE_DAYS = 30;
